module.exports = __webpack_public_path__ + "static/img/Ramiro_Ramirez_crew.86d6be5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/crew/Ramiro_Ramirez_crew.jpg
// module id = 240
// module chunks = 0